import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, input } from '@angular/core';

@Component({
  selector: 'app-label',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex gap-1 items-center">
      <label class="text-zinc-800 font-medium">
        <ng-content />
      </label>
      @if (required()) {
      <span class=" size-1.5 rounded-full bg-primary-500"></span>
      }
    </div>
  `,
})
export class Label {
  required = input<boolean, string | boolean>(false, {
    transform: booleanAttribute,
  });
}
